'use client';

import MicrosoftButton from '@/components/login/MicrosoftButton';
import { ROUTES } from '@/configs/routes';
import { authClient } from '@/lib/auth-client';
import { useTranslations } from 'next-intl';
import { useTransition } from 'react';

const MicrosoftProvider = () => {
  const t = useTranslations('LoginPage');
  const [isPending, startTransition] = useTransition();

  const onMicrosoftLoginClick = () => {
    startTransition(async () => {
      await authClient.signIn.social({ provider: 'microsoft', callbackURL: ROUTES.HOME });
    });
  };

  return (
    <MicrosoftButton isPending={isPending} onClick={onMicrosoftLoginClick}>
      {t('microsoftButton')}
    </MicrosoftButton>
  );
};

export default MicrosoftProvider;
